// extracted by mini-css-extract-plugin
export var badge = "_sb-4";
export var selected = "_sb-1";
export var selectedOverlay = "_sb-5";
export var thumbnailButton = "_sb-0";
export var thumbnailFallback = "_sb-3";
export var thumbnailImage = "_sb-2";